import { useSearchParams } from "react-router-dom";
import { FadeUp } from "../components/Motion";
import LeadForm from "../components/LeadForm";
import { Phone, Mail, MapPin, Instagram, Facebook } from "lucide-react";
import { LocalBusinessSchema } from "../components/SeoSchema";
import PageMeta from "../components/PageMeta";

export default function Contact() {
  const [params] = useSearchParams();
  const type = params.get("type") || "general";
  const leadType = type === "commercial" ? "commercial" : type === "estimate" ? "residential" : "general";

  const title = type === "commercial"
    ? "Request a commercial proposal."
    : type === "estimate"
    ? "Get a free estimate."
    : "Begin a conversation.";

  return (
    <div data-testid="contact-page" className="pt-32 pb-32">
      <PageMeta
        title="Contact NorthCrest Landscaping — Edmonton, Alberta"
        description="Request a free landscape estimate or commercial proposal. Call (780) 655-7604 or email northcrestedmonton@gmail.com. Serving Edmonton and surrounding areas."
        path="/contact"
      />
      <LocalBusinessSchema />
      <section className="px-6 md:px-12 lg:px-16 mb-16">
        <FadeUp>
          <div className="overline text-[#8C1D30] mb-4">Contact</div>
          <h1 className="font-serif-display text-5xl md:text-7xl lg:text-8xl leading-none max-w-5xl">
            {title.split(".")[0]}<span className="italic text-[#D8D6D0]">.</span>
          </h1>
        </FadeUp>
      </section>

      <section className="px-6 md:px-12 lg:px-16 grid grid-cols-1 md:grid-cols-12 gap-16">
        <FadeUp className="md:col-span-7">
          <div className="nc-card p-8 md:p-12">
            <LeadForm leadType={leadType} source={`contact-${type}`} compact />
          </div>
        </FadeUp>
        <FadeUp delay={0.15} className="md:col-span-5 space-y-10">
          <div>
            <div className="overline text-[#D8D6D0]/50 mb-3">Studio</div>
            <p className="text-[#F5F3EF] flex items-start gap-3"><MapPin className="w-4 h-4 mt-1 text-[#8C1D30]" /> Edmonton, Alberta<br/>& surrounding areas</p>
          </div>
          <div>
            <div className="overline text-[#D8D6D0]/50 mb-3">Phone</div>
            <a href="tel:+17806557604" className="text-[#F5F3EF] flex items-center gap-3 hover:text-[#D8D6D0] transition-colors"><Phone className="w-4 h-4 text-[#8C1D30]" /> (780) 655-7604</a>
          </div>
          <div>
            <div className="overline text-[#D8D6D0]/50 mb-3">Email</div>
            <a href="mailto:northcrestedmonton@gmail.com" className="text-[#F5F3EF] flex items-center gap-3 hover:text-[#D8D6D0] transition-colors"><Mail className="w-4 h-4 text-[#8C1D30]" /> northcrestedmonton@gmail.com</a>
          </div>
          <div>
            <div className="overline text-[#D8D6D0]/50 mb-3">Follow</div>
            <div className="flex gap-4">
              <a href="https://www.instagram.com/northcrestlandscaping.edmonton/" target="_blank" rel="noopener noreferrer" className="text-[#F5F3EF] flex items-center gap-2 hover:text-[#D8D6D0] transition-colors"><Instagram className="w-4 h-4 text-[#8C1D30]" /> Instagram</a>
              <a href="https://www.facebook.com/profile.php?id=61590468096615" target="_blank" rel="noopener noreferrer" className="text-[#F5F3EF] flex items-center gap-2 hover:text-[#D8D6D0] transition-colors"><Facebook className="w-4 h-4 text-[#8C1D30]" /> Facebook</a>
            </div>
          </div>
          <div>
            <div className="overline text-[#D8D6D0]/50 mb-3">Service Areas</div>
            <p className="text-[#D8D6D0]/70 text-sm leading-relaxed">Edmonton · St. Albert · Sherwood Park · Beaumont · Leduc · Spruce Grove · Fort Saskatchewan</p>
          </div>
        </FadeUp>
      </section>
    </div>
  );
}
